import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { Lock } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import IconWithTooltip from "components/IconWithTooltip";

const IntentProjectsTableLockedCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {intentProject.lockedBy ? (
        <IconWithTooltip icon={Lock} tooltip={`Locked by ${intentProject.lockedBy}`} noShrink />
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default IntentProjectsTableLockedCell;
